import { BaseRoute } from './BaseRoute';
import { SecureRoute } from './SecureRoute';

import { Dashboard } from '../components/Dashboard';
import { LogList } from '../components/Log';
import { UserList, ViewUser, AddUser, EditUser } from '../components/User';
import { AddStation, EditStation, StationList, ViewStation } from '../components/Station';
import { AddProject, EditProject, ProjectList, ViewProject } from '../components/Project';
import { AddCampaign, CampaignList, EditCampaign, ViewCampaign } from '../components/Campaign';
import { AddSample, EditSample, SampleList, ViewSample } from '../components/Sample';
import { AddParameter, EditParameter, ParameterList, ViewParameter } from '../components/Parameter';
import { StationcategoryList, ViewStationcategory } from '../components/Stationcategory';
import { ParametercategoryList, ViewParametercategory } from '../components/Parametercategory';
import { AddResult, EditResult, ResultList, ViewResult } from '../components/Result';
import { Analysis } from '../components/Analysis';
import { ParameterMap } from '../components/ParameterMap/ParameterMap';

//
// Routes are named so that they can be referred to in a Menu.
// Sign-in, forgot-password and reset-password are owned by Keycloak; there are
// no public routes — access is gated by Keycloak before the app renders.
//
interface IRoutes {
  [key:string]: BaseRoute
}

const ROUTES: IRoutes = {
  users_list:        new SecureRoute('can_view_users', '/users', 'Users', UserList),
  users_add:         new SecureRoute('can_edit_users', "/users/add", "Add User", AddUser),
  users_edit:        new SecureRoute('can_edit_users', "/users/edit/:id", "Edit User", EditUser),
  users_view:        new SecureRoute('can_view_users', "/users/:id", "User", ViewUser),

  logs_list:         new SecureRoute('can_view_logs', "/logs", "Log", LogList),

  projects_list:     new SecureRoute('can_view_projects', '/projects', 'Projects', ProjectList),
  projects_add:      new SecureRoute('can_edit_projects', "/projects/add", "Add Project", AddProject),
  projects_edit:     new SecureRoute('can_edit_projects', "/projects/edit/:id", "Edit Project", EditProject),
  projects_view:     new SecureRoute('can_view_projects', "/projects/:id", "Project", ViewProject),

  campaigns_list:     new SecureRoute('can_view_campaigns', '/campaigns', 'Campaigns', CampaignList),
  campaigns_add:      new SecureRoute('can_edit_campaigns', "/campaigns/add", "Add Campaign", AddCampaign),
  campaigns_edit:     new SecureRoute('can_edit_campaigns', "/campaigns/edit/:id", "Edit Campaign", EditCampaign),
  campaigns_view:     new SecureRoute('can_view_campaigns', "/campaigns/:id", "Campaign", ViewCampaign),

  stations_list:     new SecureRoute('can_view_stations', '/stations', 'Stations', StationList),
  stations_add:      new SecureRoute('can_edit_stations', "/stations/add", "Add Station", AddStation),
  stations_edit:     new SecureRoute('can_edit_stations', "/stations/edit/:id", "Edit Station", EditStation),
  stations_view:     new SecureRoute('can_view_stations', "/stations/:id", "Station", ViewStation),

  samples_list:      new SecureRoute('can_view_samples', '/samples', 'Samples', SampleList),
  samples_add:       new SecureRoute('can_edit_samples', "/samples/add", "Add Sample", AddSample),
  samples_edit:      new SecureRoute('can_edit_samples', "/samples/edit/:id", "Edit Sample", EditSample),
  samples_view:      new SecureRoute('can_view_samples', "/samples/:id", "Sample", ViewSample),

  parameters_list:   new SecureRoute('can_view_parameters', '/parameters', 'Parameters', ParameterList),
  parameters_add:    new SecureRoute('can_edit_parameters', "/parameters/add", "Add Parameter", AddParameter),
  parameters_edit:   new SecureRoute('can_edit_parameters', "/parameters/edit/:id", "Edit Parameter", EditParameter),
  parameters_view:   new SecureRoute('can_view_parameters', "/parameters/:id", "Parameter", ViewParameter),

  stationcategories_list:   new SecureRoute('can_view_stationcategories', '/stationcategories', 'Station categories', StationcategoryList),
  stationcategories_view:   new SecureRoute('can_view_stationcategories', "/stationcategories/:id", "Station category", ViewStationcategory),

  parametercategories_list:   new SecureRoute('can_view_parametercategories', '/parametercategories', 'Parameter categories', ParametercategoryList),
  parametercategories_view:   new SecureRoute('can_view_parametercategories', "/parametercategories/:id", "Parameter category", ViewParametercategory),

  results_list:      new SecureRoute('can_view_results', '/results', 'Results', ResultList),
  results_add:       new SecureRoute('can_edit_results', "/results/add", "Add Result", AddResult),
  results_edit:      new SecureRoute('can_edit_results', "/results/edit/:id", "Edit Result", EditResult),
  results_view:      new SecureRoute('can_view_results', "/results/:id", "Result", ViewResult),

  analysis:          new SecureRoute('can_view_results', "/analysis", "Analysis", Analysis),
  map:               new SecureRoute('can_view_results', "/map", "Map", ParameterMap),

  dashboard:         new SecureRoute(null, "/", "Dashboard", Dashboard),
};

export { ROUTES };
